import type { EstimatorSettings } from "@forgepoint/shared";
import { BusinessDaysNote } from "./BusinessDaysNote";
import { NumberSettingField } from "./NumberSettingField";

interface EstimatorSettingsFormProps {
  value: EstimatorSettings;
  onChange: (value: EstimatorSettings) => void;
}

/** Settings form for the Estimator "My Queue" template. */
export function EstimatorSettingsForm({
  value,
  onChange,
}: EstimatorSettingsFormProps) {
  return (
    <div className="space-y-5">
      <BusinessDaysNote />
      <NumberSettingField
        label="Blocked-task threshold (business days)"
        description="A queued estimate counts as waiting on others once someone else's task is open this long."
        value={value.blockedTaskMinDays}
        onChange={(blockedTaskMinDays) =>
          onChange({ ...value, blockedTaskMinDays })
        }
      />
    </div>
  );
}
